/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{getAnimatableNone as t}from"../../render/dom/value-types/animatable-none.js";import{isAnimatable as n}from"./is-animatable.js";import{isNone as o}from"./is-none.js";function e(e,r,l,i){const s=n(r,l);let m;m=Array.isArray(l)?[...l]:[null,l];const f=void 0!==i.from?i.from:e.get();let a;const p=[];for(let t=0;t<m.length;t++)null===m[t]&&(m[t]=0===t?f:m[t-1]),o(m[t])&&p.push(t),"string"==typeof m[t]&&"none"!==m[t]&&"0"!==m[t]&&(a=m[t]);if(s&&p.length&&a)for(let n=0;n<p.length;n++){m[p[n]]=t(r,a)}return m}export{e as getKeyframes};
//# sourceMappingURL=keyframes.js.map
